import type { RideSchema } from '../../types/simulation';

const PICKUP_PREFIX = 'Pickup Address';
const DROPOFF_PREFIX = 'Dropoff Address';

function normalizedAddress(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

function formatPickupAddress(index: number): string {
  return `${PICKUP_PREFIX} ${index}`;
}

function formatDropoffAddress(index: number): string {
  return `${DROPOFF_PREFIX} ${index}`;
}

function normalizedIndex(index: number): number {
  return Number.isFinite(index) && index > 0 ? Math.floor(index) : 1;
}

export function applyRideAddressPlaceholders(ride: RideSchema, index: number): RideSchema {
  const ordinal = normalizedIndex(index);
  return {
    ...ride,
    from_address: normalizedAddress(ride.from_address) ?? formatPickupAddress(ordinal),
    to_address: normalizedAddress(ride.to_address) ?? formatDropoffAddress(ordinal),
  };
}

export function applyRideAddressPlaceholdersToList(rides: RideSchema[]): RideSchema[] {
  return rides.map((ride, idx) => applyRideAddressPlaceholders(ride, idx + 1));
}

export function lineAddressPlaceholders(
  line: Record<string, unknown>,
  index: number
): { from_address: string; to_address: string } {
  const ordinal = normalizedIndex(index);
  const fromAddress =
    normalizedAddress(line.from_address) ??
    normalizedAddress(line.fromAddress) ??
    normalizedAddress(line.pickup_address) ??
    normalizedAddress(line.pickupAddress) ??
    formatPickupAddress(ordinal);
  const toAddress =
    normalizedAddress(line.to_address) ??
    normalizedAddress(line.toAddress) ??
    normalizedAddress(line.dropoff_address) ??
    normalizedAddress(line.dropoffAddress) ??
    formatDropoffAddress(ordinal);
  return { from_address: fromAddress, to_address: toAddress };
}

